import React from "react";
import routes from "./routes";
import { PrivateRoute } from "./privateRoute";
import { Switch } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "./App.css"; 
import { useHistory } from "react-router-dom";

// import {db} from "./firebase";

// db.collection("products").add({
//   HGP_treated: false,
//   Seller: {name: "John A", country: "United States", address: "Fairhope, Alabama"},
//   accreditations: "MAS",
//   age: "1 year",
//   breed: "Droughtmaster",
//   condition: "Condition",
//   delivery: "Freightlancer",
//   description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.t is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now.",
//   feed: "Limited Grain & Pasture",
//   fertility: "Wil Guarantee Fertile",
//   frame: "Frame",
//   horns: "Polled",
//   image: "pro-1.png",
//   location: "Fairhope, Alabama, United States",
//   memberSince: "July 4, 2019",
//   price: 1600,
//   regNumber: "AAA 17916048",
//   scrotalCirc: "Average 38.1 cm",
//   sex: "Male",
//   species: "Angus Bulls",
//   teeth: "Not Mounthed",
//   tickStatus: "Ticket Free Zone",
//   title: "Angus Bulls",
//   vaccinations: "Vira. Shield 6+ VL5 , MultiMin 90",
// });

const App = (props) => {
  let history = useHistory();

  return (
    <React.Fragment>
      {/* <Suspense fallback={<FullPageLoader />}> */}
      {console.log("prooops",history,props)}
      <div className="wrapper">
        <Switch>
          {routes.map((route, index) => {
            return (
              <PrivateRoute
                key={index}
                path={route.path}
                exact={route.exact}
                access={true}
                history={history}
                component={(props) => (
                  <route.layout {...props}>
                    <route.component {...props} />
                  </route.layout>
                )}
              />
            );
          })}
        </Switch>
      </div>
      {/* </Suspense> */}
    </React.Fragment>
  );
};

export default App;
